import { forwardRef } from 'react';

import { DatePicker } from '../../../../../../common/form/date-picker';
import { Form, IFormImperativeHandleProps } from '../../../../../../common';
import { IDateStepFormProps } from './date-step-form.models';
import { useStyles } from './date-step-form.styles';

export const DateStepForm = forwardRef<IFormImperativeHandleProps, IDateStepFormProps>(({
  minDate, maxDate, defaultValues, onSubmit, selectedColor, onDateChange,
}, ref): JSX.Element => {
  const classes = useStyles();

  return (
    <Form
      ref={ref}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      className={classes.root}
    >
      <DatePicker
        name="date"
        variant="static"
        minDate={minDate}
        maxDate={maxDate}
        selectedColor={selectedColor}
        getValue={onDateChange}
      />
    </Form>
  );
});
